import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = ({ className = '' }) => {
  return (
    <div className={`text-center space-y-6 ${className}`}>
      {/* Logo */}
      <div className="flex justify-center">
        <div className="w-16 h-16 lg:w-20 lg:h-20 bg-primary rounded-2xl flex items-center justify-center shadow-card">
          <Icon name="Users" size={32} color="white" className="lg:w-10 lg:h-10" />
        </div>
      </div>

      {/* App Name */}
      <div>
        <h1 className="text-2xl lg:text-3xl font-bold text-text-primary">
          ContactSync Pro
        </h1>
        <p className="text-text-secondary mt-2 text-sm lg:text-base">
          Streamline your relationships with automated care
        </p>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h2 className="text-xl lg:text-2xl font-semibold text-text-primary">
          Welcome Back
        </h2>
        <p className="text-text-secondary text-sm lg:text-base max-w-sm mx-auto">
          Sign in to your account to manage contacts and never miss a birthday again
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;